<app-content-card [title]="title" icon="sim_card">
  @if (mostrarSelector) {
    <app-selector-sim-disponible
      [conSim]="conSim"
      (seleccion)="alSeleccionar($event)"
    ></app-selector-sim-disponible>
  }
  <div class="sim-form-grid" [formGroup]="formGroup">
    <mat-form-field appearance="outline" class="no-hint">
      <mat-label>ICCID</mat-label>
      <input
        matInput
        formControlName="iccid"
        placeholder="Ingresá el ICCID"
        (blur)="checkDuplicado()"
      />
      <mat-icon matPrefix>badge</mat-icon>
    </mat-form-field>

    <mat-form-field appearance="outline" class="no-hint">
      <mat-label>Número de teléfono</mat-label>
      <input
        matInput
        formControlName="numero"
        type="tel"
        placeholder="+54 9 11 XXXX-XXXX"
        (blur)="checkDuplicado()"
      />
      <mat-icon matPrefix>phone</mat-icon>
    </mat-form-field>

    <!-- ng-select emite el operador elegido (string), no { value } -->
    <ng-select
      formControlName="operador"
      placeholder="Operador"
      [items]="operadores"
      (change)="onOperadorChange($event)"
      appendTo="body"
      notFoundText="Sin resultados"
    ></ng-select>

    <mat-form-field appearance="outline" class="no-hint">
      <mat-label>APN</mat-label>
      <input
        type="text"
        placeholder="datos.personal.com"
        matInput
        formControlName="apn"
        [matAutocomplete]="autoApn"
        (focus)="onApnFocus()"
      />
      <mat-icon matPrefix>language</mat-icon>
      <mat-autocomplete
        #autoApn="matAutocomplete"
        (optionSelected)="onApnSelected($event.option.value)"
      >
        @for (option of filteredApnOptions | async; track option) {
          <mat-option [value]="option">{{ option }}</mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field appearance="outline" class="no-hint">
      <mat-label>Usuario</mat-label>
      <input matInput formControlName="usuario" type="text" />
      <mat-icon matPrefix>person</mat-icon>
    </mat-form-field>

    <mat-form-field appearance="outline" class="no-hint">
      <mat-label>Password</mat-label>
      <input matInput formControlName="password" type="text" />
      <mat-icon matPrefix>lock</mat-icon>
    </mat-form-field>
  </div>

  @if (cargandoCheck) {
    <div class="sim-check-loading">
      <mat-spinner diameter="20"></mat-spinner>
      <span>Verificando duplicados...</span>
    </div>
  }

  @if (duplicado && !cargandoCheck) {
    <div class="sim-duplicado-warning">
      <mat-icon>warning</mat-icon>
      <span>
        Esta SIM ya está asignada al {{ tipoLabel }}
        <strong>{{ duplicado.nombre }}</strong>
        (SIM {{ duplicado.simNumero }})
      </span>
      @if (permitirMover) {
        <button irxBoton="peligro" (click)="moverSim()">
          <mat-icon>drive_file_move</mat-icon>
          Mover aquí
        </button>
      }
    </div>
  }
</app-content-card>
